

























































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import * as proxy from "@/lib/service-proxies/service-proxies";
import vueformmodel from "../../../lib/vueformmodel";
import { FormItem, Row } from "view-design";
@Component
export default class suppliermanageaddoredit extends vueformmodel {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop() id: number | undefined;
  @Prop() disabled : Boolean;
  model: proxy.ChannelTypeDto = new proxy.ChannelTypeDto();
  allchannels = [];
  channels = [];
  // channelids = [];
  channelTypeChannels = [];
  merchants = [];
  // disabled = false;
  groupflags = [];
  flag = '';
  showModal = false;
  modalDisabled = false;
  columns4 = [
    {
      title: "序号",
      width: 80,
      slot: "xuhao",
    },
    {
      title: "名称",
      key: "channelName",
    },
    {
      title: "权重",
      slot: "weight",
    },
    {
      title: "状态",
      slot: "channelStatus",
    },
  ];
  get prox() {
    return new proxy.ChannelTypeServiceProxy();
  }
  syncrate() {
    if (!this.flag) {
      this.merchants.map(x => {
        x.rate = this.model.rate;
      })
    } else {
      debugger;
      this.merchants.map(x => {
        if (x.groupFlag == this.flag) {
          this.$set(x, 'rate', this.model.rate)
        }
      })
    }
    this.merchants = this.merchants.filter(x => 1 == 1);
  }
  quanxuan() {
    this.merchants.map(x => {
      x.check = true;
    })
    this.$forceUpdate();
  }
  clearxuanzhong() {
    this.merchants.map(x => {
      x.check = false;
    })
    this.$forceUpdate();
  }
  jinyongchange(e) {
    if (e) {
      this.channels = this.allchannels.filter((x) => x.status == 0);
    } else {
      this.channels = this.allchannels;
    }
  }
  rowchange(row, index) {
    this.channelTypeChannels[index] = row;
  }
  
  cancel() {
    (this.$refs.roleForm as any).resetFields();
    this.$emit("input", false);
  }
  created() {
    
  }

  addChannels(){
      this.modalDisabled = true;
      this.showModal = true;
      this.allchannels = [];
      if(this.channels.length > 0){
          this.modalDisabled = false;
          return;
      }
      let req = new proxy.ChannelSimpleInputDto();
      new proxy.ChannelServiceProxy().queryAllList(req).then((x) => {
          this.allchannels = x;
          this.channels = this.allchannels;
          this.modalDisabled = false
          // this.allchannels.map(a => {
          //     this.$set(a, 'isSelect', false)
          //     var index = this.model.channelTypeChannels.findIndex(c => c.channelId == a.id)
          //     if(index != -1){
          //         a.isSelect = true;
          //     }
          // })
      });
  }

  channelidschange(ids) {
      let arr = this.channels.filter((x) => ids.includes(x.id));
      let arr2 = [];
      arr.map((x) => {
      let m = {
          channelName: x.name,
          channelStatus: x.status,
          weight: 1,
          id: 0,
          channelId: x.id,
      };
      if (
          this.model.channelTypeChannels &&
          this.model.channelTypeChannels.length
      ) {
          let index = this.model.channelTypeChannels.findIndex(
          (p) => p.channelId == x.id
          );
          if (index != -1) {
          m.id = this.model.channelTypeChannels[index].id;
          if (this.model.channelTypeChannels[index].weight > 0) {
              m.weight = this.model.channelTypeChannels[index].weight;
          }
          }
      }
      arr2.push(m);
      });
      this.channelTypeChannels = arr2;
  }

  save() {
      this.model.channelTypeChannels = [];
          this.channelTypeChannels.map((x) => {
          let m = new proxy.ChannelTypeChannelDto();
          m.id = x.id;
          m.channelId = x.channelId;
          m.weight = x.weight;
          this.model.channelTypeChannels.push(m);
      });
      (this.$refs.roleForm as any).validate(async (valid: boolean) => {
      if (valid) {
          this.prox.saveChannelTypeChannel(this.model).then(() => {
          (this.$refs.roleForm as any).resetFields();
          this.$Notice.success({ title: "保存成功" });
          this.$emit("save-success");
          this.$emit("input", false);
          });
      }
      });
  }

  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.disabled = true
      this.prox.queryChannelTypeChannel(this.id).then((x) => {
        this.model = x;
        this.channelTypeChannels = x.channelTypeChannels.filter(x=>x.channelName !=null)
        this.disabled = false
      });
    }
  }

  roleRule = {
    suppName: [
      {
        required: true,
        message: this.L("FieldIsRequired"),
        trigger: "blur",
      },
    ],
  };
}
